import { Fragment } from "react";
import styled, { useTheme } from "styled-components";
import { IScheduleFilters, StatusType } from "../common/interfaces/ScheduleFilters";
import { CancelIcon } from "./Icons";

const ScheduleFiltersWrapper = styled.div`
	display: flex;
	overflow-x: auto;
	overflow-y: hidden;
	width: 100%;
	gap: 5px;
	box-sizing: border-box;
`;

const FilterWrapper = styled.div`
	display: flex;
	align-items: center;
	background-color: #eadced;
	border-radius: 8px;
	gap: 6px;
	box-sizing: border-box;
	height: 26px;
	padding: 6px;
	// Typography
	font-size: 12px;
	line-height: 18.86px;
	font-weight: 400;
	font-family: Livvic;
	color: #002b49;
	white-space: nowrap;
`;

interface ScheduleFiltersProps {
	filters: IScheduleFilters;
	handleChangeFilters: (filters: IScheduleFilters) => void;
}

const StatusMap = {
	PENDENTE: "Agendados",
	CANCELADO: "Cancelados",
	FINALIZADO: "Realizados",
};

const ScheduleFilters = ({ filters, handleChangeFilters }: ScheduleFiltersProps) => {
	const { colors } = useTheme();

	const handleFilter = (key: keyof IScheduleFilters, value: string) => {
		switch (key) {
			case "status":
				return StatusMap[value as StatusType] || "";
			default:
				return value;
		}
	};

	const handleRemoveFilter = (key: keyof IScheduleFilters) => {
		filters[key] = undefined;
		handleChangeFilters(filters);
	};

	return (
		<ScheduleFiltersWrapper>
			{Object.entries(filters).map(([key, value]) => {
				if (value) {
					return (
						<FilterWrapper key={key}>
							{handleFilter(key as keyof IScheduleFilters, value)}
							<div onClick={() => handleRemoveFilter(key as keyof IScheduleFilters)}>
								<CancelIcon size={13} color={colors.secondary} />
							</div>
						</FilterWrapper>
					);
				}
				return <Fragment key={key} />;
			})}
		</ScheduleFiltersWrapper>
	);
};
export default ScheduleFilters;
